import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominaDocumentosComprobantedeposito', NominaDocumentosComprobantedeposito)

function NominaDocumentosComprobantedeposito($http, $api) {
  this.get = _get
  this.post = _post
  this.delete = _delete
  this.link = _link

  function _get(idEmpresa, idNomina) {
    return $http.get('/api/nominas/nomina/documentos/comprobantedeposito', {
      params: {idEmpresa: idEmpresa, idNomina: idNomina},
    })
  }

  function _post(idEmpresa, idNomina, file) {
    let data = new FormData()
    data.append('archivo', file)

    return $http.post('/api/nominas/nomina/documentos/comprobantedeposito', data, {
      params: {idEmpresa: idEmpresa, idNomina: idNomina},
      clearCache: 'nominas',
    })
  }

  function _delete(idEmpresa, idNomina) {
    return $http.delete('/api/nominas/nomina/documentos/comprobantedeposito', {
      params: {idEmpresa: idEmpresa, idNomina: idNomina},
      clearCache: 'nominas',
    })
  }

  function _link(idEmpresa, idNomina) {
    return $api.link('/api/nominas/nomina/documentos/comprobantedeposito', {
      idEmpresa: idEmpresa, idNomina: idNomina, i: (Math.random() * 100).toFixed(3),
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Documentos/Comprobantedeposito.js